import Vue from 'vue'
import { platform } from '@/services/platform'

// 常量：目录接口为空时使用的安全默认结构，保证页面始终可读取数组字段。
const EMPTY_CATALOG = {
  plans: [],
  tracks: []
}

// 关键状态：目录数据在当前应用会话内共享，避免页面与组件重复请求。
const catalogState = Vue.observable({
  catalog: null,
  plans: [],
  tracks: [],
  loading: false,
  error: null,
  requestPromise: null
})

// 方法：标准化目录赛道，展示名称与列表完全以 /catalog 返回为准。
// 名称缺失时用 code 兜底展示，不再自造展示名或占位 code；后端未返回的赛道不展示。
function normalizeTracks(catalogTracks) {
  return (Array.isArray(catalogTracks) ? catalogTracks : [])
    .map(track => {
      if (!track || !track.id) {
        return null
      }
      return {
        id: track.id,
        name: track.name || track.id,
        available: true
      }
    })
    .filter(Boolean)
}

// 方法：根据赛道 code 获取展示名称，未知 code 回退为 code 本身。
export function getTrackNameByCode(trackCode) {
  if (!trackCode) {
    return ''
  }
  const track = catalogState.tracks.find(item => item.id === trackCode)
  return (track && track.name) || trackCode
}

// 方法：初始化平台目录，并复用已完成数据或正在进行中的请求。
export function initializeCatalog() {
  // 逻辑分支：目录已成功加载后直接返回缓存，避免重复请求。
  if (catalogState.catalog) {
    return Promise.resolve(catalogState.catalog)
  }

  // 逻辑分支：多个消费者同时初始化时返回同一个 Promise。
  if (catalogState.requestPromise) {
    return catalogState.requestPromise
  }

  catalogState.loading = true
  catalogState.error = null
  catalogState.requestPromise = platform.catalog()
    .then(catalog => {
      // 关键节点：统一规整目录数据，组件可安全读取方案和赛道数组。
      const resolvedCatalog = catalog || EMPTY_CATALOG
      const normalizedTracks = normalizeTracks(resolvedCatalog.tracks)
      const normalizedCatalog = {
        ...resolvedCatalog,
        tracks: normalizedTracks
      }
      catalogState.catalog = normalizedCatalog
      catalogState.plans = Array.isArray(resolvedCatalog.plans)
        ? resolvedCatalog.plans
        : []
      catalogState.tracks = normalizedTracks
      return normalizedCatalog
    })
    .catch(error => {
      // 逻辑分支：失败后保留错误并继续抛出，使页面可展示错误提示。
      catalogState.error = error
      throw error
    })
    .finally(() => {
      // 关键节点：请求结束后清空 Promise；失败时下次使用即可自动重试。
      catalogState.loading = false
      catalogState.requestPromise = null
    })

  return catalogState.requestPromise
}

export default {
  state: catalogState,
  initializeCatalog,
  getTrackNameByCode
}
